import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative bg-teal-800" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"h-56 bg-teal-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2\"><img class=\"w-full h-full object-cover\" src=\"https://res.cloudinary.com/millsit/image/upload/v1648245198/TOT/heromain_jmzzkk.jpg\" alt=\"\"></div><div class=\"relative max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16\"><div class=\"md:ml-auto md:w-1/2 md:pl-10\"><p class=\"mt-2 text-white text-3xl font-extrabold tracking-tight sm:text-4xl\"> Entire Villa </p><p class=\"mt-3 text-lg text-gray-300\"> The entire villa is great for family gatherings, providing a unique combination of privacy and independence for all. It can accommodate as many as 18 people, 6 in the main house, and 4 in each cabana. </p><p class=\"mt-3 italic text-lg text-gray-300\">Book online and select &#39;entire villa&#39; (when available)</p></div></div>", 2)
const _hoisted_4 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'EntireVillaCTA',
  setup(__props) {

// import { ExternalLinkIcon } from "@heroicons/vue/solid/esm/index.js";


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}
}

})